var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-tab",
    { attrs: { tab: _vm.tab } },
    [
      _c(
        "w-scroll-view",
        { style: { height: "100%" } },
        [
          _vm.tab == "pageSettings"
            ? _c("app-page-settings", { attrs: { layout: _vm.layout } })
            : _vm.tab == "textBlocks"
            ? _c("app-text-block-list-settings", {
                attrs: { layout: _vm.layout },
              })
            : _vm.tab == "barcodes"
            ? _c("app-barcode-list-settings", { attrs: { layout: _vm.layout } })
            : _vm.tab == "qrcodes"
            ? _c("app-qr-code-list-settings", { attrs: { layout: _vm.layout } })
            : _vm.tab == "images"
            ? _c("app-image-list-settings", { attrs: { layout: _vm.layout } })
            : _vm.tab == "zpl"
            ? _c("app-zpl", { attrs: { layout: _vm.layout } })
            : _vm.tab == "epson"
            ? _c("app-epson", { attrs: { layout: _vm.layout } })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }